module.exports = __webpack_public_path__ + "static/04-16afdea4730363ec38b2553f444a9019.jpg";